var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.75V1.75M18 6.75V1.75M6.75 11.75H19.25M4.25 24.25H21.75C22.413 24.25 23.0489 23.9866 23.5178 23.5178C23.9866 23.0489 24.25 22.413 24.25 21.75V6.75C24.25 6.08696 23.9866 5.45107 23.5178 4.98223C23.0489 4.51339 22.413 4.25 21.75 4.25H4.25C3.58696 4.25 2.95107 4.51339 2.48223 4.98223C2.01339 5.45107 1.75 6.08696 1.75 6.75V21.75C1.75 22.413 2.01339 23.0489 2.48223 23.5178C2.95107 23.9866 3.58696 24.25 4.25 24.25Z",
    stroke: "#343A40",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c39f4abc7f080c7fa97aa0f6bbcc715c.svg";
export { ForwardRef as ReactComponent };